import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class AssetMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AssetMetaModule,
            providers: [
                providePageMeta({
                    title: 'Assets',
                    translationKey: 'page_assets',
                    routerLink: '/assets',
                    sidebarSection: 'Automations',
                    svgIcon: 'uipath:assets',
                    permission: 'Assets.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    priority: 3,
                }),
            ],
        };
    }
}
